// module to export tool icons as dict
const iconsNamesDict = {
  html: 'HTML',
  css: 'CSS',
  js: 'JavaScript',
  mongodb: 'MongoDB',
  react: 'React',
  nodejs: 'Node.js',
  expressjs: 'Express.js',
  python: 'Python',
  mysql: 'MySQL',
  java: 'Java',
  joget: 'Joget DX',
  pandas: 'Pandas',
  metabase: 'Metabase',
  wordpress: 'WordPress',
  tableau: 'Tableau',
  bluehost: 'Bluehost',
  beautifulsoup: 'BeautifulSoup',
  excel: 'Excel',
  jupyter: 'Jupyter Notebook',
  reactbootstrap: 'React Bootstrap',
  tkinter: 'Tkinter',
  sass: 'Sass',
  cpp: 'C++',
  reactnative: 'React Native',
  vscode: "VSCode Extension",
  nextjs: 'Next.js',
};

export default iconsNamesDict;
